import PropTypes from "prop-types";

import { ProjectFeatures } from "src/utils/constants/project-detail";
import { createProjectDescriptions } from "src/helpers/project-detail/overview-helpers";

import styles from "./styles.module.css";

const ProjectOverview = ({
  locationInfo,
  projectType,
  residenceType,
  isImmediateDelivery,
  date,
  roomCount,
  unitCount,
  percentageOfDelivery,
  percentageOfSale,
}) => {
  const descriptions = createProjectDescriptions({
    locationInfo,
    projectType,
    residenceType,
    isImmediateDelivery,
    date,
    roomCount,
    unitCount,
    percentageOfDelivery,
    percentageOfSale,
  });

  const features = ProjectFeatures.filter((feature) => descriptions[feature.key]).map((feature, index) => ({
    id: index + 1,
    ...feature,
    description: descriptions[feature.key],
  }));

  return (
    <div className={styles.wrapper}>
      <b className={styles.title}>Genel Özellikler</b>
      <div className={styles.features}>
        {features.map((feature) => (
          <div key={feature.id} className={styles.featureCard}>
            <feature.icon />
            <div className={styles.featureContent}>
              <div className={styles.featureLabel}>{feature.title}</div>
              <div className={styles.featureText}>{feature.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ProjectOverview.propTypes = {
  locationInfo: PropTypes.object,
  projectType: PropTypes.array,
  residenceType: PropTypes.array,
  isImmediateDelivery: PropTypes.bool,
  date: PropTypes.string,
  roomCount: PropTypes.array,
  unitCount: PropTypes.array,
  percentageOfDelivery: PropTypes.number,
  percentageOfSale: PropTypes.number,
};

export default ProjectOverview;
